/**
 * 数据字典相关接口
 */

import Service from '@/utils/request';

const eventsDictApi = {
    /**
     * 获取事件状态数据字典
     * @param {*} params
     * @returns Promise<any>
     */
    fetchEventStatusDic: (params={}) =>{ 
      return new Promise((resolve, reject) => {
          Service.get('/system/dict/data/type/event_status', { params }).then(res => {
              let list = []
              let dicMap = {} 
              if (res.code == 200) {
                  list = res.data
              }
              if(list.length>0){
                  list.forEach(item => {
                    dicMap[item.dictValue] = item.dictLabel
                  });
              }
              resolve({
                dicMap,
                data:list
              })
          })
      })
      
    },

    /**
     * 按字典类型获取数据字典
     * @param {string} dictType 字典类型
     * @param {object} params 额外查询参数
     * @returns Promise<{dicMap: Record<string, string>, data: Array}>
     */
    fetchDictByType: (dictType, params = {}) => {
        return new Promise((resolve, reject) => {
            Service.get(`/system/dict/data/type/${dictType}`, { params }).then(res => {
                let list = [];
                let dicMap = {};
                if (res.code == 200) {
                    list = res.data;
                }
                if (list.length > 0) {
                    list.forEach(item => {
                        dicMap[item.dictValue] = item.dictLabel;
                    });
                }
                resolve({
                    dicMap,
                    data: list,
                });
            });
        });
    },

}

export default {
  ...eventsDictApi
}
